// extracted by mini-css-extract-plugin
export var root = "MainFooter-module--root--3GSQT";
export var small = "MainFooter-module--small--33SJm";
export var list = "MainFooter-module--list--3Zm2n";
export var listInline = "MainFooter-module--listInline--2XSNX";
export var icon = "MainFooter-module--icon--20uyo";